import { returnMoreAccessLink } from "constants/layout";
import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import menuService from "services/menuService";

const getTranslateMenuName = (t, menuName, menuCode) => {
  return t(`menu_code.${menuCode}`) !== `menu_code.${menuCode}`
    ? t(`menu_code.${menuCode}`)
    : menuName;
};

// List Menu
export const useListMenu = (onSuccess, onError) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation(["menuManagement"]);
  const { addToast } = useToasts();

  return useQuery(["menu"], () => menuService.listMenu(), {
    enabled: false,
    retry: 1,
    onSuccess: response => {
      const { data } = response;

      const menu = data.data;
      const accessLinkList = [];

      // Convert Menu Name - Code - More Access Link
      const convertMenu = data => {
        data.forEach(item => {
          const { accessLink, children } = item;

          item.menuName = getTranslateMenuName(t, item.menuName, item.menuCode);
          item["moreAccessLink"] = returnMoreAccessLink(item.menuCode);

          if (accessLink && !accessLinkList.some(x => x === accessLink)) {
            accessLinkList.push(accessLink);
          }

          if (item.moreAccessLink && item.moreAccessLink.length > 0) {
            item.moreAccessLink.forEach(x => {
              if (!accessLinkList.some(y => y === x)) {
                accessLinkList.push(x);
              }
            });
          }

          if (children) {
            convertMenu(children);
          }
        });
      };
      convertMenu(menu);

      // Check Access Menu
      const pathNameAllow = [
        // "/dashboard",
        "/login",
        "/logout",
        "/profile",
        "/#",
      ];
      if (location?.pathname && !pathNameAllow.includes(location.pathname)) {
        if (
          !accessLinkList.find(item => location.pathname.indexOf(item) !== -1)
        ) {
          navigate("/pages-404");
        }
      }

      if (typeof onSuccess === "function") {
        onSuccess({
          items: menu || [],
          success: true,
        });
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);

      addToast(
        errorResponse?.message ||
          t("message.list", { target: t("menu"), status: t("message.error") }),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );

      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// List Function Role
export const useListFunctionRole = (payload = {}, onSuccess, onError) => {
  const { t } = useTranslation(["menuManagement"]);
  const { addToast } = useToasts();

  const { isEnabled = false } = payload;

  return useQuery(
    ["function-roles", "all"],
    () => menuService.listFunctionRole(payload),
    {
      enabled: isEnabled || false,
      retry: 1,
      onSuccess,
      staleTime: 10 * 60 * 1000,
      cacheTime: 0,
      // refetchInterval: 10000,
      // refetchIntervalInBackground: true,

      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("function_role"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data.data || [],
        };
      },
    }
  );
};
